import { cn } from '@/lib/utils';

interface ToggleOption {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

interface BrutalToggleGroupProps {
  options: ToggleOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function BrutalToggleGroup({ options, value, onChange, className }: BrutalToggleGroupProps) {
  return (
    <div className={cn("flex border-[3px] border-dark", className)}>
      {options.map((option, index) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={cn(
            "flex-1 px-3 py-2 font-medium text-sm transition-colors",
            index > 0 && "border-l-[3px] border-dark",
            value === option.value 
              ? "bg-primary text-dark font-bold" 
              : "bg-card hover:bg-surface"
          )}
        >
          {option.icon && <span className="mr-1.5">{option.icon}</span>}
          {option.label}
        </button>
      ))}
    </div>
  );
}
